export enum BlockMode {
    Full = 'full',
    Readonly = 'readonly',
}
